<template>
  <div>
    <b-row align-v="center" class="d-flex align-items-center">
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $t("billing_finance.month") }}</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="monthFilter"
          :options="[
            'Enero',
            'Febrero',
            'Marzo',
            'Abril',
            'Mayo',
            'Junio',
            'Julio',
            'Agosto',
            'Septiembre',
            'Octubre',
            'Noviembre',
            'Diciembre',
          ]"
          class="w-100"
          @input="(val) => $emit('update:monthFilter', val)"
          append-to-body
          :calculate-position="withPopper"
          :clearable="true"
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label>{{ $t("billing_finance.year") }}</label>
        <b-form-input
          :value="yearFilter"
          type="number"
          min="0"
          class="w-100"
          @input="
            (v) => $emit('update:yearFilter', v !== '' && v != null ? Number(v) : null)
          "
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label>{{ $t("billing_finance.region") }}</label>
        <b-form-input
          :value="regionFilter"
          type="text"
          class="w-100"
          @input="(v) => $emit('update:regionFilter', v !== '' && v != null ? v : null)"
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label>{{ $t("inventory.fields.rems") }}</label>
        <b-form-input
          :value="remsFilter"
          type="number"
          min="0"
          class="w-100"
          :placeholder="$t('id') || 'ID'"
          @input="
            (v) => $emit('update:remsFilter', v !== '' && v != null ? Number(v) : null)
          "
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $tc("unit.title", 1) }}</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="unitFilter"
          :options="unitOptions"
          class="w-100"
          multiple
          :reduce="(val) => val.value"
          @input="(val) => $emit('update:unitFilter', val)"
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label>{{ $t("billing_finance.security_company") }}</label>
        <b-form-input
          :value="companyFilter"
          type="text"
          class="w-100"
          @input="(v) => $emit('update:companyFilter', v !== '' && v != null ? v : null)"
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label>{{ $t("billing_finance.type_of_guard") }}</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="typeOfGuardFilter"
          :options="['Fija', 'Variable']"
          class="w-100"
          @input="(val) => $emit('update:typeOfGuardFilter', val)"
          append-to-body
          :calculate-position="withPopper"
          :clearable="true"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BCard, BCardHeader, BCardBody, BRow, BCol, BButton } from "bootstrap-vue";
import vSelect from "vue-select";
import popperHelper from "@/libs/popper-helper";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BButton,
    vSelect,
  },
  props: {
    tenantOptions: {
      type: Array,
      default: null,
    },
    yearOptions: {
      type: Array,
      default: null,
    },
    tenantFilter: {
      type: Array,
      default: null,
    },
    unitOptions: {
      type: Array,
      default: null,
    },
    unitFilter: {
      type: Array,
      default: null,
    },
    remsFilter: {
      type: Number,
      default: null,
    },
    statusFilter: {
      type: String,
      default: null,
    },
    yearFilter: {
      type: Number,
      default: null,
    },
    companyFilter: {
      type: String,
      default: null,
    },
    regionFilter: {
      type: String,
      default: null,
    },
    typeOfGuardFilter: {
      type: String,
      default: null,
    },
    monthFilter: {
      type: String,
      default: null,
    },
  },
  setup() {
    return {
      withPopper: popperHelper.withPopper,
    };
  },
};
</script>

